import type { CustomDisplayTextLabelPart } from '@vista-digital/occ-domain'
import type { NavigateFunction } from 'react-router-dom'
import { urlService } from '../services/url.service'
import { CmsDisplayTextLabel, CmsLink } from '../cmsTypes'

export const openInNewTab = href => {
    Object.assign(document.createElement('a'), {
        target: '_blank',
        href: href,
    }).click()
}

export const cmsToOccDisplayText = (
    label: CmsDisplayTextLabel[],
    navigate?: NavigateFunction,
    internalActions?: { [key: string]: string }
): Array<string | CustomDisplayTextLabelPart> => {
    return (
        label?.map(l => {
            if (l.link) {
                return getLink(l.link, navigate)
            } else {
                if (internalActions) {
                    for (const key in internalActions) {
                        if (l.text.indexOf(key) >= 0) return getInternalAction(l.text, internalActions[key])
                    }
                }
                return l.text
            }
        }) ?? []
    )
}

const getLink = (link: CmsLink, navigate?: NavigateFunction): CustomDisplayTextLabelPart => {
    return {
        text: link.name,
        href: link.url,
        openInNewTab: link.target && link.target === '_blank' ? true : false,
        onClick: () => {
            linkClick(link, link.target && link.target === '_blank' ? true : false, navigate)
        },
    }
}

const linkClick = (link: CmsLink, newTab: boolean, navigate?: NavigateFunction) => {
    if (!newTab && urlService.isRouted(link.url)) {
        setTimeout(() => {
            if (navigate) navigate(link.url)
            else window.navigate(link.url)
        }, 10)
    } else {
        if (newTab) openInNewTab(link.url)
        else document.location.assign(link.url)
    }
}

const getInternalAction = (text: string, internalAction: string): CustomDisplayTextLabelPart => {
    return {
        text: text,
        internalAction: internalAction,
    }
}
